import React, { useRef, useEffect } from "react";
import useStyles from './styles';
import Message from "./Message";
import WarningMessage from "./WarningMessage";
import UpdatePhoneMessage from "./UpdatePhoneMessage";

const Chat = ({ messages, driverName, delay }) => {
    const messagesEndRef = useRef(null)
    const classes = useStyles();

    useEffect(() => {
        scrollToBottom()
    }, [messages]);

    const scrollToBottom = () => {
        messagesEndRef.current.scrollIntoView({ behavior: "smooth" })
    }

    return (
      <>
        <div className={classes.container} id={`chat-container`} data-cy={`chat-container`}>
            {
                !!messages &&
                messages.map( (message, key) => {
                  switch(message?.type) {
                    case 'warning_update_phone':
                      return (<UpdatePhoneMessage key={`update-phone-message-${key}`} message={message} id={`chat-update-phone-message`} data-cy={`chat-update-phone-message`}/>);
                    case 'chat':
                      return (<Message key={`chat-message-${key}`} message={message} id={`chat-message`} data-cy={`chat-message`}/>);
                    case 'warning_call_timeout':
                      return (<WarningMessage key={`warning-timeout-message-${key}`} driverName={driverName} delay={delay} id={`chat-warning-timeout-message`} data-cy={`chat-warning-timeout-message`}/>);
                    default:
                      return null;
                  }
                })
            }

            <div ref={messagesEndRef} id={`message-ref`} data-cy={`message-ref`}/>
        </div>
        <div className={classes.hLine} id={`opaque-horizontal-line-id`} data-cy={`opaque-horizontal-line-data-cy`}></div>
      </>
    );
}

export default Chat;
